export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/pt-br.lyaml"));
at({ "pt-br": { "public": { "sampleString": "String de exemplo" } } });
};